function TraderAMCReport() {
    return (
        <div>
            <h2>Trader AMC Report</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default TraderAMCReport;